module.exports = __webpack_public_path__ + "img/国企单位.31767df3.png";